import { orchestrator } from 'satcheljs';
import { contactSupport } from '../actions/contactSupport';
import { hideFullOptions } from 'owa-options-core';
import { logUsage } from 'owa-analytics';

export default orchestrator(contactSupport, async function contactSupport() {
    hideFullOptions();
    logUsage('PremiumDashContactPremiumSupport', null, { isCore: true });
});
